<template>
	<div class="app">
		<!-- 固定头部 -->
		<div class="header" v-show="!cookiesOpen && !formOpen">
			<!-- <headerCont ref="headerCont" @navToLink="navToLink" :isMobile="isMobile"></headerCont> -->
			<!-- <headerContNew :scrolledDown="scrolledDown" ref="headerCont" @navToLink="navToLink"
				@openSearch="openSearch"></headerContNew> -->
			<headerContNew :scrolledDown="scrolledDown" ref="headerCont" @navToLink="navToLink"></headerContNew>
		</div>
		<!-- 内容区域 -->
		<div class="content" v-show="!isMobile || (!cookiesOpen && !formOpen)" @click="closeHeaderMobileMenu">
			<keep-alive>
				<router-view />
			</keep-alive>
			<cookiesNew v-if="isShowMobileOfficialWebsiteAlert"></cookiesNew>
			<!-- <pcCookies v-if="!isMobile && cookiesTipsOpen && isShowMobileOfficialWebsiteAlert"></pcCookies>
			<cookiesTips v-if="isMobile && cookiesTipsOpen && isShowMobileOfficialWebsiteAlert"
				@openCookies="openCookies" @closeTips="closeTips"></cookiesTips>
			<formPc v-if="!isMobile && formOpen"></formPc> -->
			<officialWebsiteAlert v-if="isShowOfficialWebsiteAlert"></officialWebsiteAlert>
		</div>
		<!-- 固定底部 -->
		<div class="bottom" v-show="!isMobile || (!cookiesOpen && !formOpen)">
			<bottomContNew></bottomContNew>
			<!-- <bottomContMobile v-if="isMobile" :title="title" />
			<bottomCont v-else /> -->
		</div>
		<!-- 移动端cookies -->
		<!-- <cookies v-if="isMobile && cookiesOpen" @close="close"></cookies> -->
		<!-- 移动端表单
		<formMobile v-if="isMobile && formOpen"></formMobile> -->
		<!-- 查询 -->
		<!-- <search-dropdown v-if="isSearch" @closeSearch="closeSearch"></search-dropdown> -->
		<!-- 一键到顶部的按钮 -->
		<transition name="back-to-top">
			<div class="to-top" v-if="toTop">
				<div class="btn" @click="scrollToTop">
					<i class="el-icon-arrow-up icon-lg" @click=""></i>
				</div>

			</div>
		</transition>

	</div>
</template>

<script>
import headerCont from './components/headerCont'
import headerContNew from './components/headerContNew.vue';
import bottomCont from './components/bottomCont'
import bottomContNew from './components/bottomContNew.vue';
import bottomContMobile from './components/bottomContMobile';
import cookiesNew from './page/finally/cookies.vue'
// import pcCookies from './page/pc/cookies.vue'
// import formMobile from './page/mobile/form.vue';
// import formPc from './page/pc/form.vue';
// import cookies from './page/mobile/cookies.vue';
// import cookiesTips from './page/mobile/cookiesTips.vue';
import officialWebsiteAlert from './components/officialWebsiteAlert.vue'
import { bus } from './utils/bus';
import searchDropdown from './components/search-dropdown.vue'
export default {
	name: 'KOMO',
	components: {
		headerCont,
		headerContNew,
		bottomCont,
		bottomContNew,
		bottomContMobile,
		// pcCookies,
		// formMobile,
		// cookies,
		// cookiesTips,
		// formPc,
		officialWebsiteAlert,
		searchDropdown,
		cookiesNew
	},
	data() {
		return {
			toTop: false,
			scrolledDown: false,   // 是否已离开顶部
			isSearch: false, //控制搜索框的显示
			isMobile: false,   // 默认先给 false，避免闪烁
			title: '', //接受顶部路由跳转时回传的标题
			cookiesOpen: false,
			cookiesTipsOpen: true,
			formOpen: false
		}
	},
	computed: {
		isShowOfficialWebsiteAlert() {
			const storedTimestamp = localStorage.getItem('alertClosedTimestamp');
			if (!storedTimestamp) return true;

			const threeDaysInMs = 3 * 24 * 60 * 60 * 1000; // 3天的毫秒数
			const currentTimestamp = new Date().getTime();
			const timeDiff = currentTimestamp - parseInt(storedTimestamp);

			return timeDiff > threeDaysInMs;
		},
		isShowMobileOfficialWebsiteAlert() {
			const storedTimestamp = localStorage.getItem('isShowMobileOfficialWebsiteAlert');
			if (!storedTimestamp) return true;

			const threeDaysInMs = 7 * 24 * 60 * 60 * 1000; // 7天的毫秒数
			const currentTimestamp = new Date().getTime();
			const timeDiff = currentTimestamp - parseInt(storedTimestamp);

			return timeDiff > threeDaysInMs;
		},
	},
	mounted() {
		// this.isMobile = this.checkMobile()
		// console.log(this.isMobile)
		// if (!this.isMobile) {
		// 	window.addEventListener('resize', this.handleResize);
		// }
		// window.scrollTo(0, 0)
		this.$nextTick(() => {
			setTimeout(() => {            // 宏任务，确保浏览器已定位完
				this.onScroll()             // 如果仍 > 0 就让它 true，否则 false
			}, 0)
		})
		this.onScroll()
		window.addEventListener('scroll', this.onScroll, { passive: true })
	},
	beforeDestroy() {        // 组件销毁时清掉监听
		window.removeEventListener('scroll', this.onScroll)
	},
	methods: {
		scrollToTop() {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		},
		openSearch(val) {
			this.isSearch = val
		},
		closeSearch(val) {
			this.isSearch = val
		},
		onScroll() {
			this.scrolledDown = window.scrollY > 0

			this.toTop = window.scrollY > 1000
		},

		// 在某些情况下关闭移动端菜单
		closeHeaderMobileMenu() {
			console.log('11111111111111111')
			if (this.$refs.headerCont && this.$refs.headerCont.isMobileMenuOpen) {
				this.$refs.headerCont.isMobileMenuOpen = false;
			}
		},
		handleResize() {
			// 刷新页面逻辑
			window.location.reload();
		},
		checkMobile() {
			const ua = navigator.userAgent
			return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
		},
		navToLink(title) {
			this.title = title;
		},
		openCookies() {
			console.log('openCookies');
			this.cookiesTipsOpen = false;
			this.cookiesOpen = true;
		},
		closeTips() {
			localStorage.setItem('isShowMobileOfficialWebsiteAlert', new Date().getTime());
			this.cookiesTipsOpen = false;
		},
		close() {
			this.cookiesOpen = false;
		}

	},
	beforeCreate() {
		// 监听子页面发回来的事件
		bus.$on('inquiry-form', val => {
			this.formOpen = val !== undefined ? val : !this.formOpen
		})
	},
	beforeDestroy() {
		bus.$off('inquiry-form')   // 记得解绑
	},
}
</script>
<style>
.el-message {
	z-index: 9999 !important;
	position: fixed !important;
	top: 10% !important;
	left: 50% !important;
	transform: translateX(-50%) !important;
}
</style>
<style scoped>
@import 'components/common.css';

body {
	margin: 0;
	padding: 0;
	font-family: "Source Han Sans CN", "思源黑体", sans-serif !important;
}

#app {
	/* font-family: Avenir, Helvetica, Arial, sans-serif; */
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
}

.app {
	width: 100%;
	height: 100%;
	position: relative;
}

.header {
	width: 100%;
	position: fixed;
	z-index: 99999;
	background: transparent;
	/* height: 5vw;
	background-color: #D5DCC8; */
}

.content {
	width: 100%;
	height: 100%;
	position: relative;
}


.bottom {
	width: 100%;
	/* height: 550px; */
	background-color: #F8F9FC;
}

/* 跳转到顶部按钮样式 */
.to-top {
	position: fixed;
	bottom: 40px;
	right: 40px;
	z-index: 99;
}

/* 进入：从下往上 */
.back-to-top-enter-active {
	animation: slideInUp .3s ease-out;
}

/* 离开：从上往下 */
.back-to-top-leave-active {
	animation: slideInUp .3s ease-out reverse;
}

@keyframes slideInUp {
	from {
		opacity: 0;
		transform: translateY(30px);
		/* 从下 */
	}

	to {
		opacity: 1;
		transform: translateY(0);
		/* 回到原位 */
	}
}

.btn {
	background: #442d22;
	width: 44px;
	height: 44px;
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	overflow: hidden;
}

.btn:hover {
	background-color: #442d22;
}

.btn:hover:after {
	background-image: linear-gradient(90deg, transparent, hsla(0, 0%, 100%, .25), transparent);
	content: "";
	height: 100%;
	left: 150%;
	position: absolute;
	top: 0;
	transform: skew(-20deg);
	width: 200%;
	animation: shineAgain .75s cubic-bezier(.01, .56, 1, 1);
}
.btn:active{
	background-color: #442d22!important;
	color: #ffffff!important;
	border: #442d22!important;
}

.icon-lg {
	font-size: 20px;
	color: #ffffff;
}

@media (max-width:990px) {
	.header {
		height: 55px;
	}
}
</style>
